/* global dataLayer */

import { Controller } from 'stimulus';
import axios from 'axios';
import toArray from '../helpers/toArray';
import getControllerForElement from '../helpers/getControllerForElement';

class OrderForm extends Controller {
  onSubmit(event) {
    if (!document.body.classList.contains('ab-test')) {
      return;
    }

    event.preventDefault();

    const id = event.currentTarget.getAttribute('data-variant-id');
    const sku = event.currentTarget.getAttribute('data-variant-sku');
    const price = event.currentTarget.getAttribute('data-variant-price');
    const quantity = this.quantityTarget.value;

    this.addToCart(id, quantity);
    this.sendToGTM(id, sku, price);
  }

  async addToCart(id, quantity) {
    try {
      const { data: res } = await axios.post(this.element.getAttribute('action'), {
        product_variant_id: id,
        quantity,
      });

      await this.updateCartCount(res.product_items_count);
      await this.showAlert();
    } catch (err) {
      // console.error(err);
    }
  }

  updateCartCount(count) {
    const output = toArray(document.querySelectorAll('.js-header-cart-items'));

    output.forEach((element) => {
      element.setAttribute('data-cart-items-count', count);
    });
  }

  showAlert() {
    const alert = document.querySelector('[data-controller="alert"]');

    getControllerForElement(this.application, alert, 'alert')
      .then((controller) => {
        controller.show();
      });
  }

  // eslint-disable-next-line
  sendToGTM(id, sku, price) {
    if (typeof dataLayer === 'undefined') {
      return;
    }

    dataLayer.push({
      event: 'addToCart',
      conversion_value: price || 0,
      product_variant_id: id,
      product_variant_sku: sku,
    });
  }
}

OrderForm.targets = [
  'quantity',
];

export default OrderForm;
